import { __awaiter } from "tslib";
import axios from 'axios';
import { map } from 'lodash';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCryptoEncryptFileFunction } from './cryptoApi';
import { useODataReadInfiniteApi, } from './odata';
import { getFormattedFileName } from './cryptoApi/getFormattedFileName';
import { merge } from '@fluentui/utilities';
const endpointAttach = (caseId) => `/portal/v2.0/vulnerabilityReport/${caseId}/File.Attach`;
const endpointFile = `/portal/v2.0/file`;
/**
 * Continuous API for viewing the metadata of a user's uploaded files
 * (filenames and dates, no content for security reasons)
 */
export const useVulnReportFileMetadataInfiniteApi = (query, options) => useODataReadInfiniteApi(endpointFile, query, merge({}, {
    isAuthRequired: true,
    isVerificationRequired: true,
}, options));
/** API for uploading encrypted files associated with a vulnerability report */
export const useVulnReportFileMutationApi = (additionalInvalidateEndpoints) => {
    const queryClient = useQueryClient();
    const cryptoApi = useCryptoEncryptFileFunction();
    return useMutation(['files'], ({ reportNumber, file }) => __awaiter(void 0, void 0, void 0, function* () {
        const endpointName = endpointAttach(reportNumber);
        if (!reportNumber) {
            return Promise.reject('Tried to upload a file without specifying a report number');
        }
        if (cryptoApi.error) {
            return Promise.reject(cryptoApi.error);
        }
        if (cryptoApi.isLoading) {
            return Promise.reject('Key still loading');
        }
        if (!cryptoApi.encryptFile) {
            return Promise.reject('Something went very wrong getting key');
        }
        const { encryptedFile, kid, wrappedKey } = yield cryptoApi.encryptFile(file);
        const formBody = new FormData();
        formBody.append(getFormattedFileName(file.name), new Blob([encryptedFile], { type: 'application/octet-stream' }));
        const axiosConfig = {
            headers: {
                'x-wrapped-key': JSON.stringify({
                    EncryptedKey: wrappedKey,
                    KeyId: kid,
                }),
            },
        };
        return yield axios.post(endpointName, formBody, axiosConfig);
    }), {
        onSuccess: () => {
            queryClient.invalidateQueries(['files']);
            queryClient.invalidateQueries([endpointFile]);
            map(additionalInvalidateEndpoints, e => {
                queryClient.invalidateQueries([e]);
            });
        },
    });
};
